"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwpppUpdateErrorTypes = void 0;
var SwpppUpdateErrorTypes;
exports.SwpppUpdateErrorTypes = SwpppUpdateErrorTypes;

(function (SwpppUpdateErrorTypes) {
  SwpppUpdateErrorTypes["SWPPP_UPDATE_MISSING_DATE_SUBMITTED"] = "swppp_update_missing_date_submitted";
})(SwpppUpdateErrorTypes || (exports.SwpppUpdateErrorTypes = SwpppUpdateErrorTypes = {}));